import { render } from "./EditJobIndex.vue?vue&type=template&id=3a5d55be"
import script from "./EditJobIndex.vue?vue&type=script&lang=js"
export * from "./EditJobIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__